import type { ReportTemplate } from '../schemas';
import { DEFAULT_TEMPLATE_GROUPS } from './groups';
import { CHIUSURA_SECTIONS } from './sections/chiusura';
import { CENTRALI_SECTIONS_CONTROLLI, CENTRALI_SECTIONS_PRIMARY } from './sections/centrali';
import { FRONTESPIZIO_SECTIONS } from './sections/frontespizio';
import {
  CENTRALI_SECTIONS_EMERGENZA,
  CENTRALI_SECTIONS_VERIFICHE,
  VERIFICHE_SECTIONS_FINAL,
  VERIFICHE_SECTIONS_PRIMARY,
  VERIFICHE_SECTIONS_SECONDARY,
} from './sections/verifiche';

export { DEFAULT_TEMPLATE_GROUPS };

export const DEFAULT_TEMPLATE_SECTIONS: ReportTemplate['sections'] = [
  ...FRONTESPIZIO_SECTIONS,
  ...CENTRALI_SECTIONS_PRIMARY,
  ...CENTRALI_SECTIONS_VERIFICHE,
  ...CENTRALI_SECTIONS_EMERGENZA,
  ...CENTRALI_SECTIONS_CONTROLLI,
  ...VERIFICHE_SECTIONS_PRIMARY,
  ...VERIFICHE_SECTIONS_SECONDARY,
  ...VERIFICHE_SECTIONS_FINAL,
  ...CHIUSURA_SECTIONS,
];
